// extracted by mini-css-extract-plugin
export var carrierIcon = "_xx-0";
export var carrierLogo = "_xx-1";
export var detailsSection = "_xx-2";